import React from 'react'

const Projects = () => { 

    return <p>Projects Goes Here</p>
}

export default Projects